import React from 'react';

export default function WhatsappEngagementCard() {
  return (
    <div className="wa-engagement-card" style={{
      background: '#275c53', // updated company theme color
      borderRadius: 16,
      padding: '30px 28px',
      color: '#fff',
      boxShadow: '0 4px 24px 0 rgba(60,72,88,0.10)',
      minHeight: 200,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      position: 'relative',
      overflow: 'hidden',
    }}>
      <div className="wa-engagement-heading" style={{ fontWeight: 700, fontSize: 18, marginBottom: 8, lineHeight: 1.3 }}>
        Start WhatsApp Engagement with CampaigningTool
      </div>
      <div className="wa-engagement-paragraph" style={{ fontSize: 13.5, opacity: 0.95, marginBottom: 20, lineHeight: 1.5 }}>
        To use WhatsApp messaging for your business, apply for WhatsApp Business API with CampaigningTool.<br/>
        Begin your API application or migrate your existing setup below.
      </div>
      <div className="wa-engagement-btn-group" style={{ display: 'flex', gap: 14, marginBottom: 18, flexWrap: 'wrap' }}>
        <button className="wa-engagement-btn wa-engagement-btn-primary" style={{
          background: '#fff',
          color: '#275c53',
          border: 'none',
          borderRadius: 8,
          padding: '12px 20px',
          fontWeight: 600,
          fontSize: 15,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 8,
          cursor: 'pointer',
          transition: 'transform 0.15s ease, box-shadow 0.15s ease',
        }}>
          <span style={{ fontSize: 18, color: '#275c53' }}>🟢</span> Apply for WhatsApp Business API (FREE)
        </button>
        <button className="wa-engagement-btn wa-engagement-btn-secondary" style={{
          background: 'transparent',
          color: '#fff',
          border: '2px solid #fff',
          borderRadius: 8,
          padding: '12px 20px',
          fontWeight: 600,
          fontSize: 15,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 8,
          cursor: 'pointer',
          transition: 'transform 0.15s ease, background 0.15s ease',
        }}>
          <span style={{ fontSize: 18 }}>➡️</span> Migrate from Another Provider
        </button>
      </div>
      <a href="#" className="wa-engagement-link" style={{ color: '#fff', textDecoration: 'underline', fontSize: 14, lineHeight: 1.4, zIndex: 2 }}>
        Want to know more about CampaigningTool? Click to schedule a Live Demo.
      </a>
      <div className="wa-engagement-rocket" style={{ position: 'absolute', right: 20, bottom: 12, pointerEvents: 'none' }}>
        <span style={{ fontSize: 75, opacity: 0.2 }}>🚀</span>
      </div>
      <style>{`
        @media (max-width: 768px) {
          .wa-engagement-card {
            padding: 20px 16px !important;
            border-radius: 14px !important;
          }
          .wa-engagement-heading {
            font-size: 16px !important;
          }
          .wa-engagement-paragraph {
            font-size: 13px !important;
            margin-bottom: 16px !important;
          }
          .wa-engagement-btn-group {
            flex-direction: column !important;
            gap: 10px !important;
            width: 100% !important;
            margin-bottom: 16px !important;
          }
          .wa-engagement-btn {
            width: 100% !important;
            padding: 11px 16px !important;
            font-size: 14px !important;
            text-align: center !important;
          }
          .wa-engagement-link {
            font-size: 13px !important;
          }
          .wa-engagement-rocket {
            opacity: 0.1 !important;
            right: 10px !important;
            bottom: 5px !important;
          }
        }
      `}</style>
    </div>
  );
} 